import React from 'react';

import LanguageSelector from '../languageSelector/LanguageSelector.js';
import {locales, getCurrentLocale} from "../../utils/getCurrentLocale";
import logo from '../images/logo.svg';

import headerStyles from './Header.module.scss';


const Header = (props) => {

    let locale = getCurrentLocale(props.location.pathname);

    return (
        <header className = {headerStyles.header}>
            <div className = {headerStyles.headerContainer}>
                <h1 className = {headerStyles.title}>{locales[locale] ? locales[locale].common.title : ""}</h1>
                <LanguageSelector location = {props.location}/>
            </div>
            <img className = {headerStyles.logo} src = {logo} alt = "Studio logo"/>
        </header>
    )
};

export default Header;
